import { SxProps } from '@mui/material';

export const invertedButtonColor = {
  backgroundColor: 'primary.main',
  color: 'common.white',
  // '&:active, &:focus-visible, &:focus:not(:focus-visible), &:not(:focus-visible)': {
  //   bgcolor: 'primary.main',
  //   color: 'common.white',
  // },
  '&:hover': {
    bgcolor: 'custom.buttonColor',
    color: 'primary.main',
    '@media (hover: none)': {
      bgcolor: 'primary.main',
      color: 'common.white',
    },
  },
  '&:disabled': {
    color: 'rgba(0, 0, 0, 0.26)',
    backgroundColor: 'rgba(0, 0, 0, 0.12)',
  },
};

export const resetButtonStyles = {
  border: 'none',
  textAlign: 'left',
  overflow: 'visible',
  background: 'transparent',
  cursor: 'pointer',
  color: 'inherit',
};

export const resetMuiButtonStyles = {
  '&:hover': {
    backgroundColor: 'transparent',
  },
  '&:focus': {
    backgroundColor: 'transparent',
  },
  '&:active': {
    backgroundColor: 'transparent',
  },
};

export const redesignButtonSx: SxProps = {
  fontFamily: 'ABC Oracle, sans-serif',
  color: 'common.white',
  letterSpacing: 0,
  backgroundColor: 'common.black',
  width: 1,
  py: 4.5,
  textTransform: 'none',
  borderRadius: 25,
  transition: 'all 0.3s ease-in-out',
  '&:hover': {
    backgroundColor: 'common.black',
    transform: 'translateY(-1px)',
    boxShadow: '0 8px 25px rgba(0, 0, 0, 0.3)',
  },
  '&:disabled': {
    backgroundColor: '#CECECE',
    color: '#F4F4F4',
  },

  '@media (hover: hover) and (pointer: fine)': {
    '&:hover': {
      bgcolor: 'common.black',
      '-webkit-text-fill-color': 'common.black',
    },
  },

  // NOTE: Ensure no styles persist on mobile after tap
  '@media (hover: none)': {
    '&:hover, &:focus, &:active': {
      bgcolor: '#181819',
      '-webkit-text-fill-color': 'common.white',
    },
  },
};
